module.exports = __webpack_public_path__ + "static/img/account__hovered.3041002.svg";